module.exports = __webpack_public_path__ + "static/avatar_michael-8f215589b3e7d075f7b6fb4a2c21f163.png";